import { Button } from '@/components';
import clipBoardIcon from '@/assets/clip-boards.svg';
import { usePortalNavigate } from '@/hooks/usePortalPath';

const NoJobsSection = () => {
  const navigate = usePortalNavigate();
  return (
    <div className="mt-4 flex flex-col items-center justify-center rounded-xl bg-white py-15 shadow">
      <img
        src={clipBoardIcon}
        alt="Clipboard Icon"
        className="h-20 w-20 rounded-sm object-cover"
      />
      <p className="mt-4 mb-2 text-lg font-semibold">
        Ready to start recruiting?
      </p>
      <p className="mt-2 mb-4 font-medium text-gray-500">
        Your dashboard is empty because you haven't posted any jobs yet.
      </p>
      <Button
        variant="primary"
        className="bg-accent-900 hover:bg-accent-700 cursor-pointer py-2"
        onClick={() => navigate('/jobs/new', { state: { from: 'dashboard' } })}
      >
        + Post a job
      </Button>
    </div>
  );
};

export default NoJobsSection;
